module.exports = __webpack_public_path__ + "img/antes_despues_278.bedb2cf9.png";